module.exports = __webpack_public_path__ + "static/TravisCI.759c31fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/TravisCI.png
// module id = 141
// module chunks = 35783957827783 226020273838829